<template>
  <div class="date-panel-layout">
    <Header type='home-header'/>
    <div v-show="showMenu" class="layer" @click="toggleShowMenu"></div>
    <el-row class="tac data-panel-wrap">
      <el-col :span="4" class="menu" :class="{show: showMenu}">
        <h5 class="panel-wrap">CRM</h5>
        <el-menu
          :default-openeds="defaultOption"
          class="bonus-menu"
          background-color="#0A0E22"
          active-text-color="#fff"
          text-color="#989AA2"
          router="router">
          <!-- 数据面板 -->
          <el-menu-item index="0" class="home-page-wrap" >
            <img class="menu-icon home-icon" src="../../assets/menu/homeIcon.png">
            <span slot="title">CRM首页</span>
          </el-menu-item>
          <!-- 标准节点待部署列表 -->
           <el-submenu index="1" >
            <template slot="title">
              <img class="menu-icon home-icon total-revenue-icon" src="../../assets/menu/liteNode.png">
              <span>需求方管理</span>
            </template>
            <!-- 标准节点待部署列表 -->
            <el-menu-item route="/crm/node" v-bind:class="{ isActive: (thisFullPath === '/crm/node') }" index="1-1">标准节点待部署列表</el-menu-item>
            <!-- 标准节点部署完成列表 -->
            <el-menu-item route="/crm/node?type=3" v-bind:class="{ isActive: (thisFullPath === '/crm/node?type=3') }" index="1-2">标准节点部署完成列表</el-menu-item>
            <!-- 标准节点 CMDB 变更 -->
            <el-menu-item route="/crm/server" index="1-3" v-bind:class="{ isActive: (thisPath === '/crm/server') }">标准节点 CMDB 变更</el-menu-item>
            <!-- 轻节点任务开关 -->
            <el-menu-item route="/crm/config"  index="1-4" v-bind:class="{ isActive: (thisPath === '/crm/config') }">轻节点任务开关</el-menu-item>
            <!-- 标准节点账单 -->
            <!-- <el-menu-item index="1-5">标准节点账单</el-menu-item> -->

          </el-submenu>
          <!-- 标准节点-->
          <el-submenu v-if="isZnWebsite" index="2" class="revenue-wrap">
            <template slot="title">
              <div v-bind:class="{ revenuePad: true }">
                <img class="menu-icon home-icon total-revenue-icon" src="../../assets/menu/standNode.png">
                <span>供给方管理</span>
              </div>
            </template>
            <el-menu-item-group :span="1">
              <!-- 白名单管理 -->
              <el-menu-item index="2-1" route="/crm/whiteList" v-bind:class="{ isActive: (thisPath === '/crm/whiteList') }">
                  白名单管理
              </el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group :span="2">
              <!-- 黑名单管理 -->
              <el-menu-item index="2-2" route="/crm/blackList" v-bind:class="{ isActive: (thisPath === '/crm/blackList') }">
                黑名单管理
              </el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group :span="3">
              <!-- 白名单余额 -->
              <el-menu-item index="2-3" route="/crm/whiteBalance" v-bind:class="{ isActive: (thisPath === '/crm/whiteBalance') }">
                白名单余额
              </el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group :span="3">
              <!-- 白名单余额 -->
              <el-menu-item index="2-3" route="/crm/balance" v-bind:class="{ isActive: (thisPath === '/crm/balance') }">
                账号余额发放
              </el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group :span="3">
              <!-- Bcode发放 -->
              <el-menu-item index="2-3" route="/crm/sendBcode" v-bind:class="{ isActive: (thisPath === '/crm/sendBcode') }">
                Bcode发放
              </el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group :span="3">
              <!-- 自动提现开通账户列表 -->
              <el-menu-item index="2-3" route="/crm/autoWithUser" v-bind:class="{ isActive: (thisPath === '/crm/autoWithUser') }">
                自动提现开通账户列表
              </el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group :span="3">
              <!-- 黑名单管理 -->
              <el-menu-item index="2-3" route="/crm/autoWithOrder" v-bind:class="{ isActive: (thisPath === '/crm/autoWithOrder') }">
                自动提现待处理列表
              </el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group :span="3">
              <!-- 黑名单管理 -->
              <el-menu-item index="2-3" route="/crm/withOrderList" v-bind:class="{ isActive: (thisPath === '/crm/withOrderList') }">
                手动提现待处理列表
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-col>
      <el-col :span="20" class="bonus-content">
        <div class="title first-title">
          <!-- title img -->
          <!-- <img v-if="thisPath === '/router'" class="title-img" src="../../assets/menu/homeIconBlack.png"/> -->
          <!-- <img v-if="ifRevenueRouters" class="title-img" src="../../assets/menu/totalRevenueBlack.png"/> -->
          <!-- <img v-if="ifStatusRouters" class="title-img" src="../../assets/menu/networdBlack.png"/> -->
          <!-- <img v-if="ifWithdrawal" class="title-img" src="../../assets/menu/withdrawalBlack.png"/> -->
          <!-- <img v-if="ifnetContribution" class="title-img" src="../../assets/menu/networkCbtBlack.png"/> -->
          {{ pageTitle }}
        </div>
        <slot></slot>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import { mapState, mapActions } from 'vuex';
const supplyManage = ['/crm/config', "/crm/server", "/crm/node"];
const getRouters = ['/crm/whiteList', "/crm/blackList", "/crm/whiteBalance", "/crm/sendBcode", "/crm/autoWithUser", "/crm/autoWithOrder", "/crm/balance", "/crm/withOrderList"];
// const statusRouters = ['/deviceOverview', '/netStatus', '/calculateStatus', '/calculateTask'];
// const otherRouters = ['/withdrawal', '/', '/networkContribution'];

export default {
  name: 'DatePanelLayout',
  props: {
    type: '',
    isRevenue: '',
    pageTitle: '',
    titleSrc: '',
  },
  components: {
    Header,
  },
  data () {
    return {
      activeIndex: '0',
      revenueActive: true,
      showMenu: false,
      whichLanguage: false
    }
  },
  computed: mapState({
    isZnWebsite: state => state.isZnWebsite,
    auth: state => state.buyBack.auth || '',
    thisPath () {
      return this.$route.path
    },
    thisFullPath () {
      return this.$route.fullPath
    },
    defaultOption () {
      let thisPath = this.$route.path
      if (supplyManage.includes(thisPath)) {
        return ['1', '1-1']
      } else if (getRouters.includes(thisPath)) {
        return ['2', '2-1', '2-2', '2-3', '2-4']
      // } else if (thisPath === '/calculateStatus'
      //   || thisPath === '/calculateDetail') {
      //   return ['3']
      // } else if (thisPath === '/dialStatus') {
      //   return ['6']
      // } else if (thisPath === '/standardStatus' || thisPath === '/standardWatch') {
      //   return ['9']
      }
    },
  }),
  created () {
    const body = document.getElementsByTagName('body')[0]
    body.classList.remove('overflow-hidden')

    // 缓存语言设置
    this.$i18n.locale = this.isZnWebsite ? 'zn' : 'en';

    this.getBuyBackAuth();
  },
  methods: {
    toggleShowMenu () {
      this.showMenu = !this.showMenu
      const body = document.getElementsByTagName('body')[0]
      if (this.showMenu) {
        body.classList.add('overflow-hidden')
      } else {
        body.classList.remove('overflow-hidden')
      }
    },
    ...mapActions(['logout', 'getBuyBackAuth']),
    // 注销
    clickLogout () {
      this.logout()
    },
    // 语言切换
    // changeLanguage (locale) {
    //   this.whichLanguage = (locale === 'zn')
    //   this.$i18n.locale = locale
    //   this.$cookie.set('NEW_BASIC_LANUAGE', locale)
    //   window.location.reload()
    // },
  },
  watch: {
    '$route' () {
      console.log('show menu change')
    }
  }
}
</script>

<style lang="stylus">
.is-mobile {
  .menu {
    display none
    position: fixed;
    right 0
    width: 220px;
    z-index: 10;
    height: calc(100% - 62px);
    overflow-y: auto;
    background: #0a0f22;
    &.show {
      display block
    }
    .panel-wrap {
      opacity 1
    }
  }
  .bonus-content {
    padding 0
    width 100%
    min-height 0
    overflow: auto;
    .first-title {
      display none
    }
  }
  .annouce .title {
    padding-left 15px
    padding-right 15px
  }
  .annouce-content {
    margin-right 15px
    margin-left 15px
  }
  .date-panel-layout {
    /deep/ .home-header {
      margin 0
      width 100%
      overflow hidden
      .header-panel {
        .exit, .lang {
          position relative
          left 0
          right 0
        }
        &:before, &:after {
          display none
        }
      }
      .header-login-panel {
        width auto
      }
    }
  }
  .layer {
    position fixed
    width 100%
    height 100%
    z-index 9
    background: rgba(0, 0, 0, 0.5);
  }
  .FAQ {
    display none
  }
  .list-tab {
    margin-right 0
    margin-left 0
  }
  .logout, .menu-item-wrapper {
    display block
  }
  .header-language {
    position relative
    right 0
  }
}

.logout, .menu-item-wrapper {
  display none
}

.revenue-wrap .revenuePad {
  padding-left: 20px;
}

.revenue-wrap .el-submenu__title {
  padding-left: 0 !important;
}

.content-wrap {
  display: flex;
  justify-content: flex-start;
}

.menu-detail {
  width: 168px;
}

.panel-wrap {
  padding-left: 25px;
  text-align: left;
  height: 40px;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  line-height: 40px;
  opacity: 0.5;
  background: #0A0F22;
  line-height: 40px;
  color: #fff;
}

.home-panel {
  height: 45px;
  line-height: 45px;
  background: #032031;
  position: relative;
}

.home-panel-border {
  position: absolute;
  left: 0;
  top: 0;
  position: absolute;
  left: 0;
  top: 0;
  background-image: linear-gradient(-180deg, #15BCAD 2%, #10B2CB 100%);
  width: 4px;
  height: 100%;
}

.home-panel-text {
  padding: 0 20px;
  color: #fff;
  font-size: 12px;
  line-height: 45px;
  display: flex;
  vertical-align: middle;
}

.home-icon {
  display: inline-block;
  margin-top: 15px;
  width: 15px;
  height: 15px;
}

.menu-panel {
  width: 168px;
  background: #000519;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
}

.bonus-menu .el-menu-item {
  height: 45px;
  line-height: 45px;
  font-size: 15px;
  text-align: left;
}

.bonus-menu .el-submenu__title {
  height: 40px;
  line-height: 40px;
  font-size: 15px;
  text-align: left;
}

.detail-wrap {
  width: 100%;
}

.title-img {
  width: 12px;
  height: 12px;
  margin-right: 5px;
}

.el-alert__title {
  font-size: 10px;
}

.home .el-menu {
  border-right: 0px;
}

.menu-icon {
  margin: -2px 8px 0 0;
  width: 12px;
  height: 12px;
}

.isActive, .el-menu-item.is-active {
  background-color: #032031;
  border-left: 3px solid #11B6BD;
  color: #fff !important;
}

.bonus-content {
  background: #F6F6F7;
  // height: 100%;
  padding: 0 35px 35px;
}

.bonus-content {
  font-family: PingFangSC-Medium;
}

.bonus-content .title {
  font-family: PingFangSC-Regular;
  font-size: 18px;
  color: #65686A;
  line-height: 45px;
  text-align: left;
  font-weight: bold;
}

.annouce {
  background: #FFFFFF;
  border: 1px solid #E3E3E7;
  position: relative;
}

.annouce .more {
  font-size: 14px;
  color: #999B98;
  text-align: right;
  line-height: 40px;
  position: absolute;
  right: 30px;
  top: 0;
}

.annouce .title {
  padding: 0 30px;
  font-size: 14px;
  color: #343739;
  line-height: 40px;
  border-bottom: 1px solid #E7EAEC;
}

.bonus-menu .el-submenu .el-menu-item {
  min-width: 20px;
}

.annouce-content {
  margin: 0 23px;
}

.header-language {
  position: absolute;
  right: 100px;
  text-align: center;
  width: 40px
}

</style>
